<template>
  <div class="panel">
    <a
      class="panel-block"
      v-for="user in users"
      :key="user.id"
      @click="userSelected(user)"
      :class="{'has-background-grey-dark': isSelectedUser(user), 'has-text-light': isSelectedUser(user)}"
    >
      <span class="panel-icon">
        <i
          class="icon-user has-text-weight-bold"
          :class="{'has-text-light': isSelectedUser(user) && !userIsPro(user),
                    'has-text-success': userIsPro(user)}"
          aria-hidden="true"
        ></i>
      </span>

      <div class="container">
        <span class="is-pulled-left">{{user.firstName}} {{user.lastName}}</span>
        <span class="is-pulled-right has-text-weight-light email">{{user.email}}</span>
      </div>

      <span
        class="pro-tag has-background-success has-text-light has-text-weight-bold"
        v-if="userIsPro(user)"
      >SUB</span>
    </a>
  </div>
</template>

<script>
import { isPro } from "./userUtils.js";

export default {
  name: "UsersList",

  props: {
    users: {
      type: Array,
      default: () => ([])
    },

    selectedUserId: {
      type: String
    }
  },

  computed: {
  },

  methods: {

    userSelected(user) {
      this.$emit('user-selected', user);
    },

    isSelectedUser(user) {
      if (!this.selectedUserId) {
        return false;
      }

      return this.selectedUserId === user.id;
    },

    userIsPro(user) {
      if (!user) {
        return false;
      }

      return isPro(user);
    }
  }
};
</script>

<style lang="scss" scoped>
.panel {
  min-width: 300px;
}

.email {
  margin-left: 1em;
}

.panel-block {
  position: relative;

  .pro-tag {
    position: absolute;
    left: 0px;
    top: 0px;
    font-size: 8px;
    padding: 0px 2px;
  }
}
</style>
